export default "__VITE_ASSET__B1MMfv30__"